import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { first, Observable, Subject, takeUntil, tap } from 'rxjs';
import {
  ObrazacUnosaDropdownOption,
  ObrazacUnosaDTO,
  ObrazacUnosaService
} from '../fast-data-entry/service/obrazac-unosa.service';

@Component({
  selector: 'app-entry-template-dropdown',
  templateUrl: './entry-template-dropdown.component.html'
})
export class EntryTemplateDropdownComponent implements OnInit, OnDestroy {
  @Input()
  public label: string;

  @Input()
  public disabled = false;

  @Input()
  public hidden = false;

  @Output()
  public selectObrazacUpisa = new EventEmitter<ObrazacUnosaDTO>();

  public selectedEntryTemplate: number;

  private obrasciUnosaService = inject(ObrazacUnosaService);

  entryTemplates$: Observable<ObrazacUnosaDropdownOption[]>;

  private destroySubject = new Subject<boolean>();

  ngOnInit(): void {
    this.entryTemplates$ =
      this.obrasciUnosaService.entryTemplateDropdownOptions$;
    this.obrasciUnosaService.selectEntryTemplate$
      .pipe(
        tap((selected) => {
          this.selectedEntryTemplate = selected.id;
        }),
        takeUntil(this.destroySubject)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroySubject.next(true);
  }

  selectEntryTemplate(event: { value: number }) {
    this.obrasciUnosaService.entryTemplates$
      .pipe(
        first(),
        tap((entryTemplates) => {
          const entryTemplate = entryTemplates.find(
            (t) => t.id === event.value
          );
          if (entryTemplate) {
            this.selectObrazacUpisa.next(entryTemplate);
          }
        })
      )
      .subscribe();
  }
}
